import {
  Component,
  OnInit,
  OnDestroy,
  signal,
  WritableSignal,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from '../../../../core/services/auth.service';
import { PersianTitlesService } from '../../../../core/services/persian-titles.service';
import { ProfileService } from '../../../profile/services/profile.service';
import { ProfileModel } from '../../../profile/models/profile.model';

@Component({
  selector: 'app-auth-bar',
  templateUrl: './auth-bar.component.html',
  styleUrls: ['./auth-bar.component.css'],
  standalone: false,
})
export class AuthBarComponent implements OnInit, OnDestroy {
  authSubscription: Subscription;

  userFullName: string;
  userAvatar: WritableSignal<string> = signal<string>(null);
  dropDownItems: Array<{
    id: number;
    text: string;
    icon: string;
    title: string;
  }>;
  profile: ProfileModel;

  constructor(
    private authService: AuthService,
    private persianTitlesService: PersianTitlesService,
    private profileService: ProfileService,
  ) {}

  ngOnInit() {
    this.authSubscription = this.authService.user.subscribe((usr) => {
      this.userFullName = usr?.fullName;
      if (usr?.avatar) {
        this.userAvatar.set(usr.avatar);
      } else {
        this.userAvatar.set(null);
      }
    });
    this.dropDownItems = [
      {
        id: 1,
        text: this.persianTitlesService.Items.Logout,
        icon: 'runner',
        title: '',
      },
    ];

    this.loadProfile();

    // Listen for default charity changes
    window.addEventListener('defaultCharityChanged', () => {
      // Force refresh of profile data
      this.loadProfile();
    });
  }

  private loadProfile() {
    this.profileService.getMyProfile().subscribe((profile) => {
      // Create ProfileModel instance to get charityTitle getter
      this.profile = new ProfileModel(
        profile.id,
        profile.firstName,
        profile.lastName,
        profile.fullName,
        profile.email,
        profile.mobileNumber,
        profile.linkedin,
        profile.cooperation_type,
        profile.lastEducationDegree,
        profile.educationField,
        profile.charities,
        profile.defaultCharityId,
        profile.positionsTitle,
        profile.hasApprovalRequired,
        profile.hasApprovalForRegistering,
        profile.avatar_id,
      );

      // Set defaultCharityId in localStorage
      if (profile.defaultCharityId) {
        let userData = JSON.parse(
          localStorage.getItem('afraTrainingPortalUserData') || '{}',
        );
        userData.defaultCharityId = profile.defaultCharityId;
        userData.defaultPositions = profile.defaultPositions;
        userData.defaultCooperationType = profile.defaultCooperationType;
        localStorage.setItem(
          'afraTrainingPortalUserData',
          JSON.stringify(userData),
        );
      }

      // Update user avatar from profile
      this.userAvatar.set(this.profile.profileAvatar);
    });
  }

  ngOnDestroy() {
    this.authSubscription.unsubscribe();
    window.removeEventListener('defaultCharityChanged', () => {
      this.loadProfile();
    });
  }
}
